/** @jsx jsx */
import { memo } from 'react';
import { graphql, useFragment } from 'react-relay';
import { jsx } from '@atlaskit/css';
import { Collapsible } from '@atlassian/jira-platform-collapsible/src/index.tsx';
import type { SaveResetViewSettingsButtonCollapsible$key } from '@atlassian/jira-relay/src/__generated__/SaveResetViewSettingsButtonCollapsible.graphql';
import { SaveResetViewSettingsButtonUI } from './SaveResetViewSettingsButtonUI.tsx';

type Props = {
	viewFragment: SaveResetViewSettingsButtonCollapsible$key;
};

export const SaveResetViewSettingsButtonCollapsible = memo(({ viewFragment }: Props) => {
	const viewMetadata = useFragment(
		graphql`
			fragment SaveResetViewSettingsButtonCollapsible on JiraIssueSearchViewMetadata
			@argumentDefinitions(staticViewInput: { type: "JiraIssueSearchStaticViewInput" }) {
				...SaveResetViewSettingsButtonUI @arguments(staticViewInput: $staticViewInput)
				... on JiraSpreadsheetView {
					viewSettings(
						groupBy: $groupBy
						staticViewInput: $staticViewInput
						issueSearchInput: $issueSearchInput
					) {
						isViewConfigModified
					}
				}
			}
		`,
		viewFragment,
	);

	return (
		<Collapsible
			animationDuration={260}
			direction="horizontal"
			isExpanded={viewMetadata.viewSettings?.isViewConfigModified ?? false}
		>
			<SaveResetViewSettingsButtonUI viewFragment={viewMetadata} />
		</Collapsible>
	);
});
